module.exports = __webpack_public_path__ + "img/photo-station-primary.1b9b4f70.svg";